/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_No_Content_FilteredInputs */



/**
* | output |
* | --- |
* | "No content matches these filters." |
*
* @param {Community_No_Content_FilteredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_no_content_filtered = /** @type {((inputs?: Community_No_Content_FilteredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_No_Content_FilteredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun contenu ne correspond à ces filtres.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ningún contenido coincide con estos filtros.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum conteúdo corresponde a estes filtros.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun contenuto corrisponde a questi filtri.")
	return /** @type {LocalizedString} */ ("No content matches these filters.")
});